'use client'

import styled from 'styled-components'

import {BodySelector} from '@/src/config/settings'
import {media} from '@/src/config/theme'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`

export const SortOptions = styled.div`
  ${BodySelector} &,
  ${BodySelector} & * {
    font-weight: 450;
    border-radius: 5px;
  }

  display: flex;
  align-items: center;
  gap: 8px;

  & > span {
    display: none;
  }

  @media ${media.lg} {
    & > span {
      display: block;
    }
  }
`
